import React from 'react';
import { Routes, Route } from "react-router-dom";
import PrivateAuth from '../../authorization/PrivateAuth';
import UserManagement from "../../../pages/User Management/UserManagement";
import UserManagementCreate from "../../../pages/User Management/UserManagement/Create";
import Roles from "../../../pages/User Management/Roles/Roles";
import Supertab from "../../../pages/Login/Supertab";
import LoginUsers from "../../../pages/User Management/Login Users/LoginUsers";
import ActivityLog from "../../../pages/User Management/Activity Log/ActivityLog";
import ApiLogTrack from '../../../pages/User Management/ApiLoginTracker/ApiLogTrack';



function UserManagementRoute() {

    return (
        <Routes>
            <Route element={<PrivateAuth />}>
                <Route path="manage-users" element={<UserManagement />} />
                <Route path="manage-users/User-Management-Create" element={<UserManagementCreate />} />
                <Route path="manage-users/Roles" element={<Roles />} />
                <Route path="super" element={<Supertab />} />
                <Route path="manage-users/Login-Users" element={<LoginUsers />} />
                <Route path="manage-users/Activity-Log" element={<ActivityLog />} />

                <Route path="login-track" element={<ApiLogTrack />} />


            </Route>

        </Routes>
    )
}
export default UserManagementRoute;